import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useBillableEvents} from '../hooks/useBillableEvents.ts';

export const ReloadRecordsButton = () => {

    const {reload} = useBillableEvents();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};
